"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssessmentTemplateClient = void 0;
const dp_http_client_lib_1 = require("@greatmindsorg/dp-http-client-lib");
const sdk_constants_1 = require("../../constants/sdk.constants");
const assessment_template_serializer_1 = require("../serializers/assessment-template.serializer");
class AssessmentTemplateClient {
    static newInstance(options, retryOptions) {
        return new AssessmentTemplateClient(dp_http_client_lib_1.RetryableHttpClient.newInstance(options, retryOptions), new assessment_template_serializer_1.AssessmentTemplateSerializer());
    }
    constructor(client, assessmentTemplateSerializer) {
        this.client = client;
        this.assessmentTemplateSerializer = assessmentTemplateSerializer;
    }
    async sync(externalId, headers) {
        await this.client.put(`${sdk_constants_1.AUTHORING_API_PREFIX}/assessmentTemplates.sync`, { externalId }, {
            headers,
        });
    }
    async delete(assessmentTemplateId, headers) {
        await this.client.delete(`${sdk_constants_1.AUTHORING_API_PREFIX}/assessmentTemplates/${assessmentTemplateId}`, {
            headers,
        });
    }
    async findOne(assessmentTemplateId, headers) {
        const response = await this.client.get(`${sdk_constants_1.AUTHORING_API_PREFIX}/assessmentTemplates/${assessmentTemplateId}`, {
            headers,
        });
        const { data } = response.body;
        return this.assessmentTemplateSerializer.serializeOne(data);
    }
    async findByExternalId(externalId, headers) {
        const response = await this.client.get(`${sdk_constants_1.AUTHORING_API_PREFIX}/assessmentTemplates.findByExternalId?externalId=${externalId}`, {
            headers,
        });
        const { data } = response.body;
        return this.assessmentTemplateSerializer.serializeOne(data);
    }
    async publish(assessmentTemplateId, headers) {
        await this.client.put(`${sdk_constants_1.AUTHORING_API_PREFIX}/assessmentTemplates.publish/${assessmentTemplateId}`, {}, {
            headers,
        });
    }
    async findByOwner(filters, pageableOptions, headers) {
        const response = await this.client.get(`${sdk_constants_1.AUTHORING_API_PREFIX}/assessmentTemplates.findByOwner`, {
            headers,
            params: { ...filters, ...pageableOptions },
        });
        const { body } = response;
        return this.assessmentTemplateSerializer.serialize(body);
    }
    async copy(assessmentTemplateId, headers) {
        const response = await this.client.post(`${sdk_constants_1.AUTHORING_API_PREFIX}/assessmentTemplates.copy/${assessmentTemplateId}`, {}, {
            headers,
        });
        const { data } = response.body;
        return this.assessmentTemplateSerializer.serializeOne(data);
    }
    async rename(assessmentTemplateId, title, headers) {
        await this.client.put(`${sdk_constants_1.AUTHORING_API_PREFIX}/assessmentTemplates.rename/${assessmentTemplateId}`, { title }, {
            headers,
        });
    }
    async createCustom(customAssessment, headers) {
        const response = await this.client.post(`${sdk_constants_1.AUTHORING_API_PREFIX}/assessmentTemplates.custom`, customAssessment, {
            headers,
        });
        const { data } = response.body;
        return this.assessmentTemplateSerializer.serializeOne(data);
    }
    async updateCustom(assessmentTemplateId, customAssessment, headers) {
        await this.client.put(`${sdk_constants_1.AUTHORING_API_PREFIX}/assessmentTemplates.custom/${assessmentTemplateId}`, customAssessment, {
            headers,
        });
    }
    async findByStandard(standardGlobalId, pageableOptions, headers) {
        const response = await this.client.get(`${sdk_constants_1.AUTHORING_API_PREFIX}/assessmentTemplates.findByStandard`, {
            headers,
            params: { standardGlobalId, ...pageableOptions },
        });
        const { body } = response;
        return this.assessmentTemplateSerializer.serialize(body);
    }
    async findAssignmentTypesByCurriculum(curriculum, headers) {
        const { body: { data }, } = await this.client.get(`${sdk_constants_1.AUTHORING_API_PREFIX}/assessmentTemplates.findAssignmentTypesByCurriculum`, {
            headers,
            params: { curriculum },
        });
        return data;
    }
    async share(assessmentTemplateId, userIds, headers) {
        const response = await this.client.put(`${sdk_constants_1.AUTHORING_API_PREFIX}/assessmentTemplates.share`, { assessmentTemplateId, userIds }, {
            headers,
        });
        return response.body.data;
    }
    async findFilterOptionsByOwner(headers) {
        const { body: { data }, } = await this.client.get(`${sdk_constants_1.AUTHORING_API_PREFIX}/assessmentTemplates.findFilterOptionsByOwner`, {
            headers,
        });
        return data;
    }
    async activate(assessmentTemplateId, headers) {
        await this.client.put(`${sdk_constants_1.AUTHORING_API_PREFIX}/assessmentTemplates.activate/${assessmentTemplateId}`, {}, {
            headers,
        });
    }
    async deactivate(assessmentTemplateId, headers) {
        await this.client.put(`${sdk_constants_1.AUTHORING_API_PREFIX}/assessmentTemplates.deactivate/${assessmentTemplateId}`, {}, {
            headers,
        });
    }
}
exports.AssessmentTemplateClient = AssessmentTemplateClient;
//# sourceMappingURL=assessment-template.client.js.map